import type { CrmIntegrationConversation } from '../types/crm-integration-chat.types'

export const matchesIntegrationChatSearch = (
  item: CrmIntegrationConversation,
  query: string,
  integrationName?: string | null,
): boolean => {
  const normalized = query.trim().toLowerCase()
  if (!normalized) {
    return true
  }

  const haystack = [
    item.title,
    item.last_message_text,
    item.external_recipient,
    item.external_user_id,
    item.lead_id != null ? String(item.lead_id) : '',
    item.lead_id != null ? `лид #${item.lead_id}` : '',
    integrationName,
    String(item.id),
  ]
    .filter((part) => part != null && String(part).trim())
    .join(' ')
    .toLowerCase()

  return haystack.includes(normalized)
}

export const filterIntegrationChatsBySearch = (
  items: CrmIntegrationConversation[],
  query: string,
  integrationNameById?: Record<number, string>,
): CrmIntegrationConversation[] => {
  const normalized = query.trim()
  if (!normalized) {
    return items
  }

  return items.filter((item) =>
    matchesIntegrationChatSearch(
      item,
      normalized,
      integrationNameById?.[item.integration_id],
    ),
  )
}
